import React, { useEffect, useRef, useState } from "react";
import historyAction from "../../assets/images/historyaction.svg";
import notificationAction from "../../assets/images/notificationaction.svg";
import notification from "../../assets/images/notification.svg";
import actionLog from "../../assets/images/actionLog.svg";
import viewAction from "../../assets/images/viewaction.svg";
import editAction from "../../assets/images/editaction.svg";
import deleteAction from "../../assets/images/deleteaction.svg";
import cube from "../../assets/images/cube.svg";
import dollar from "../../assets/images/dollar.svg";
import clocktick from "../../assets/images/clocktick.svg";
import property from "../../assets/images/property.svg";
import greenTick from "../../assets/images/greenTick.svg";
import redTick from "../../assets/images/redCross.svg";
import close from "../../assets/images/close.svg";
import clockhistory from "../../assets/images/clockhistory.svg";
import workflowsvg from "../../assets/images/workflowsvg.svg";
import { Col, Form, Overlay, Row, Tooltip } from "react-bootstrap";
import SchedularPopup from "./SchedularPopup";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LineChartWithPoint from "./LineChartWithPoint";

import LogModal from "./LogModal";
import { commonservices, CountCharacter } from "../../services/CommonServices";
import WorkFlowLogModal from "./WorkFlowLogModal";
import moment from "moment";
import { API_URL } from "../../services/APIRoute";
import DeleteModal from "../../Modals/DeleteModal";
import NotificationPopup from "./NotificationPopup";
import noDataFound from "../../assets/images/nodatafound.png";
import { useMemo } from "react";

function SingleProjectCard({
  projectName,
  cubeNo,
  dollarNo,
  timezone,
  lastRunTime,
  lastRunDate,
  nextRunTime,
  nextRunDate,
  code,
  activestatus,
  activestatusLabel,
  status,
  succeed,
  failed,
  workFlowId,
  canView,
  canedit,
  candelete,
  item,
  callFunction,
  lastRunCost,
  mtdcost,
  handleshowtypeclick,
  getTargetRef,
}) {
  // let DataItem={...item}
  const [DeletePayload, setDeletePayload] = useState({
    workflowid: "",
    status: "",
  });

  const location = useLocation();
  const [showNotification, setShowNotification] = useState(false);
  const handleshowNotification = () => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowNotification(!showNotification);
  };
  const [schedularData, setSchedularData] = useState(null);

  const [flowName, setFlowName] = useState("");
  const [CronParseValues, setCronParseValues] = useState([]);
  const notificationPayloadRef = useRef();
  const chartData = useMemo(() => {
    if (!item?.chartdata) return [];

    try {
      const chartParsedData = JSON.parse(item.chartdata);

      if (!chartParsedData?.["Chart Label"]) {
        item.isDummyData = true;
        return [];
      }

      const labels = chartParsedData["Chart Label"]?.split(",");

      const updatedLabels = labels?.map((labelItem) => {
        // Ensure proper date formatting for Safari compatibility
        // Safari requires ISO format dates (YYYY-MM-DD) or specific formats
        try {
          // Make sure date strings are properly formatted for Safari
          // Convert possible date formats to a Safari-compatible format
          // const dateObj = new Date(labelItem);
          //

          // Check if date is valid
          if (isNaN(labelItem)) {
            // Try parsing with moment if direct conversion fails
            const momentDate = moment(labelItem);
            if (momentDate.isValid()) {
              return item?.avgdaydiffrence < 28
                ? momentDate.format("DD MMM")
                : momentDate.format("MMM YY");
            } else {
              // Return original if all parsing attempts fail

              return labelItem;
            }
          }

          return item?.avgdaydiffrence < 28
            ? moment(labelItem).format("DD MMM")
            : moment(labelItem).format("MMM YY");
        } catch (e) {
          return labelItem; // Return original if parsing fails
        }
      });

      chartParsedData["Chart Label"] = updatedLabels?.toString();
      return chartParsedData;
    } catch (error) {
      return [];
    }
  }, [item?.chartdata, item?.avgdaydiffrence]);

  const memoizedChart = useMemo(
    () => <LineChartWithPoint data={chartData} />,
    [chartData],
  );

  const navigate = useNavigate();
  const [showSchedulerPopup, setShowSchedulerPopup] = useState(false);
  const handleshowSchedulerPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSchedulerPopup(!showSchedulerPopup);
  };
  const SetScheduler = (item) => {
    let schedularDataObj = {
      "WorkFlowSchedule.timezone": item?.timezone,
      "WorkFlowSchedule.startondatetime": item?.startondatetime
        ? moment(item?.startondatetime).format("YYYY-MM-DD")
        : "",
      "WorkFlowSchedule.endondatetime": item?.endondatetime
        ? moment(item?.endondatetime).format("YYYY-MM-DD")
        : "",
      "WorkFlowSchedule.scheduledays": item?.scheduledays,
      "WorkFlowSchedule.schedulemonth": item?.schedulemonth,
      "WorkFlowSchedule.hour": item?.schedulehour,
      "WorkFlowSchedule.minute": item?.scheduleminute,
      "WorkFlowSchedule.weekdays": item?.scheduleweekday,
      "WorkFlowSchedule.cronexpression": item?.cronexpression,
      "filter.minute": item?.scheduleminute === "all" ? true : false,
      "filter.hour": item?.schedulehour === "all" ? true : false,
      "filter.date": item?.scheduledays === "all" ? true : false,
    };
    setFlowName(item?.workflowname);
    setSchedularData(schedularDataObj);
  };
  const handleSchedularSubmit = (data) => {
    setSchedularData(data);
    // setCroneExpressionValue(data?.["WorkFlowSchedule.cronexpression"]);
  };

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };
  const target = useRef(null);
  const target2 = useRef(null);

  const [show, setShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  // if (item?.chartdata) {
  //   let chartParsedData = JSON.parse(item?.chartdata);
  //   if (!chartParsedData?.["Chart Label"]) {
  //     item.isDummyData = true;
  //   } else {
  //     if (item?.avgdaydiffrence < 28) {
  //       let label = chartParsedData["Chart Label"]?.split(",");
  //       let updatedLabel = label?.map((item) => {
  //         return moment(item).format("DD MMM");
  //       });
  //       chartParsedData["Chart Label"] = updatedLabel?.toString();

  //       item.chartdata = JSON.stringify(chartParsedData);
  //     } else {
  //       let label = chartParsedData["Chart Label"]?.split(",");
  //       let updatedLabel = label?.map((item) => {
  //         return moment(item).format("MMM YY");
  //       });
  //       chartParsedData["Chart Label"] = updatedLabel?.toString();
  //       item.chartdata = JSON.stringify(chartParsedData);
  //     }
  //   }
  // }

  //#region Close ToolTip / Overlays Outside Click ----------------------

  const overlayNoti_Ref = useRef(null);

  const handleOutsideClick = (event) => {
    if (
      overlayNoti_Ref.current &&
      !overlayNoti_Ref.current.contains(event.target) &&
      !target2.current.contains(event.target)
    ) {
      handleshowNotification(event); // Close the overlay
    }
  };

  useEffect(() => {
    if (showNotification) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showNotification]);

  //#endregion ----------------------

  const workspaces = item?.workspacename
    ? item.workspacename.split(",").map((w) => w.trim())
    : [];

  return (
    <div className="position-relative">
      <div className="SingleProjectCard-main common-white-bg">
        <div className="status-and-actions">
          <div className="d-flex">
            <div className="mt-1 me-1">
              {commonservices.getStatus(activestatusLabel)}
            </div>
            <span className="mt-1">
              {commonservices.getWithoutDotStatus(status)}
            </span>
          </div>

          <div className="all-actions">
            <img
              src={historyAction}
              alt="historyaction"
              title="Scheduler"
              id="Scheduler"
              className="tourWorkFlowDashboardSchedular"
              onClick={(e) => {
                e.preventDefault();
                handleOverlay(e);
                setShow(!show);
                handleshowSchedulerPopup();
                SetScheduler(item);
              }}
              ref={target}
            />

            <span
              id={`nextt${item?.workflowid}`}
              title="Notification"
              className="tourWorkFlowDashboardNotification notification-blink-btn"
              onClick={(e) => {
                e.preventDefault();
                target2.current = document.querySelector(
                  `#nextt${item?.workflowid}`,
                );
                notificationPayloadRef.current = {
                  associationId: item?.workflowid,
                  associationType: "workflow",
                };
                setShowNotification(!showNotification);
                handleshowNotification();
              }}
            >
              <img
                src={notification}
                alt="Notification"
                className="sm-icons"
                ref={target2}
              // className="sm-icons"
              />
              {/* <span className="notification-count"></span> */}
            </span>
            <img
              src={actionLog}
              alt="actionLog"
              title="Log"
              className="tourWorkFlowDashboardLog"
              onClick={() => setModalShow1(true)}
            />
            {canView && (
              <>
                {/* <Link to="/projects/project-view">
                <img src={viewAction} alt="viewAction" title="View" />
              </Link> */}
                <span
                  onClick={() => {
                    let data = commonservices.bodyEncryption(
                      `${item?.workflowid}?v=1&r=${location?.pathname?.includes("dashboard") ? "dc" : "wc"
                      }`,
                    );
                    // navigate(`/flow-new/${data}`, {
                    //   state: { isViewMode: true, flowRoleRights: item },
                    // });
                    navigate(`/flow-new-view/${data}`, {
                      state: { isViewMode: true, flowRoleRights: item },
                    });
                  }}
                >
                  <img
                    className="tourWorkFlowDashboardView"
                    src={viewAction}
                    alt="viewAction"
                    title="View"
                  />
                </span>
                {/* <Link to={`/flow/${workFlowId}`}>
                  <img src={viewAction} alt="viewAction" title="View" />
                </Link> */}
              </>
            )}
            {canedit && (
              <>
                {/* <Link to={`/flow/${workFlowId}`}>
                <img src={editAction} alt="editAction" title="Edit" />
              </Link> */}
                <span
                  onClick={() => {
                    let data = commonservices.bodyEncryption(
                      `${item?.workflowid}?v=0&r=${location?.pathname?.includes("dashboard") ? "dc" : "wc"
                      }`,
                    );
                    navigate(`/flow-new/${data}`, {
                      state: { isViewMode: false, flowRoleRights: item },
                    });
                  }}
                  className="tourWorkFlowDashboardEdit"
                >
                  <img src={editAction} alt="editAction" title="Edit" />
                </span>
              </>
            )}

            {candelete && (
              <img
                src={deleteAction}
                alt="deleteAction"
                title="Delete"
                className="tourWorkFlowDashboardDelete"
                onClick={() => {
                  setModalShow(true);
                  setDeletePayload({
                    workflowid: item?.workflowid,
                    status: "Delete",
                  });
                }}
              />
            )}
          </div>
        </div>
        <div className="project-title-detail">
          <div
            onClick={() => {
              let data = commonservices.bodyEncryption(
                `${item?.workflowid}?v=1&r=${location?.pathname?.includes("dashboard") ? "dc" : "wc"
                }`,
              );
              // navigate(`/flow-new/${data}`, {
              //   state: { isViewMode: true, flowRoleRights: item },
              // });
              navigate(`/flow-new-view/${data}`, {
                state: { isViewMode: true, flowRoleRights: item },
              });
            }}
            style={{ cursor: "pointer" }}
            className="d-flex justify-content-between theme-color-text fw600 cardtextdata"
          >
            {/* {projectName} */}
            <div className="tourWorkFlowDashboardName d-inline-block">
              {commonservices.truncateText(
                commonservices.stripHTML(projectName),
                CountCharacter.ProjectCard,
              )}
            </div>
            {workspaces.length > 0 && (
              <div className="workspace-wrapper single-market-place-main p-1 ">
                {/* First value */}
                <span className="blue-badge">{workspaces[0]}</span>

                {/* Remaining count */}
                {workspaces.length > 1 && (
                  <span className="blue-badge more-badge">
                    +{workspaces.length - 1} more
                    {/* Hover content */}
                    <div className="tooltip-content">
                      {workspaces.slice(1).map((ws, idx) => (
                        <div key={idx}>{ws}</div>
                      ))}
                    </div>
                  </span>
                )}
              </div>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-between property-and-ticks">
            <div className="d-flex align-items-center gap-2">
              <div className="d-flex align-items-center gap-1">
                <img src={workflowsvg} alt="workflowsvg" />
                <p>{code}</p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <img src={cube} alt="cube" />
                <p>{cubeNo}</p>
              </div>
            </div>
            <div className="d-flex algn-items-center gap-2 succeed-failed tourWorkFlowDashboardStatus">
              <div className="d-flex align-items-center gap-1">
                <img src={greenTick} alt="greenTick" />
                <span className="green-color-text">{succeed} Succeed</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <img src={redTick} alt="redTick" />
                <span className="red-color-text">{failed} Failed</span>
              </div>
            </div>
          </div>
        </div>
        <div className="all-project-feature projectfeacture">
          <div
            className="single-project-feature tourWorkFlowDashboardMachines cursor-pointer"
            ref={getTargetRef(item?.workflowid, "lastrun")}
            onClick={(e) => {
              e.preventDefault();
              handleshowtypeclick(
                item?.workflowname,
                item?.workflowid,
                "lastrun",
                e,
              );
            }}
          >
            <img src={dollar} alt="dollar" />
            <div>
              <p>Last Run</p>
              {/* <Link to="/scheduler/schedular-detail"> */}

              {/* <h2 className="theme-color-text">{cubeNo}</h2> */}

              <h2>
                {lastRunCost
                  ? commonservices.fnAmountDigitCount(lastRunCost, 5)
                  : 0}
              </h2>
              {/* </Link> */}
            </div>
          </div>
          <div
            className="single-project-feature tourWorkFlowDashboardBillingInfo cursor-pointer"
            ref={getTargetRef(item?.workflowid, "mtd")}
            onClick={(e) => {
              e.preventDefault();
              handleshowtypeclick(
                item?.workflowname,
                item?.workflowid,
                "mtd",
                e,
              );
            }}
          >
            <img src={dollar} alt="dollar" />
            <div>
              <p>MTD</p>
              <h2>
                {mtdcost ? commonservices.fnAmountDigitCount(mtdcost, 5) : 0}
              </h2>
              {/* <h2 className="cardcube-data">{dollarNo}</h2> */}
            </div>
          </div>
          <div className="single-project-feature tourWorkFlowDashboardLastRun">
            <img src={clocktick} alt="clocktick" />
            <div>
              <p className="card-title">Last Run Date</p>
              <p>{lastRunDate ? lastRunDate : "--:--"}</p>
              <h2>
                {lastRunTime ? lastRunTime : "--:--"}
                <span>{timezone}</span>
              </h2>
            </div>
          </div>
          <div className="single-project-feature tourWorkFlowDashboardNextRun">
            <img src={clockhistory} alt="clockhistory" />
            <div>
              <p className="card-title">Next Run Date</p>
              <p>{nextRunDate ? nextRunDate : "--:--"}</p>
              <h2>
                {nextRunTime ? nextRunTime : "--:--"}
                <span>{timezone}</span>
              </h2>
            </div>
          </div>

          {/* {status?.props?.children == "Active" && (
            <></>
          )} */}
        </div>
        <div className="tourWorkFlowDashboardGraph mt-2">
          <div className="position-relative">
            <div
              style={{ height: "100px", width: "100%" }}
              className={`${item?.isDummyData ? "chartNoDataFound" : ""}`}
            >
              {item?.isDummyData ? (
                <div className="noData">
                  <img src={noDataFound} alt="nodata" />
                  <h3>No Chart Data Found</h3>
                </div>
              ) : (
                <>{memoizedChart}</>
              )}
            </div>
          </div>
        </div>
      </div>
      {showSchedulerPopup ? (
        <Overlay
          target={target.current}
          show={showSchedulerPopup}
          placement="bottom"
        >
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <SchedularPopup
                isViewMode={
                  location?.pathname?.includes("/dashboard") ||
                  location?.pathname?.includes("/workflows")
                }
                handleSubmit={handleSchedularSubmit}
                handleshowPopup={handleshowSchedulerPopup}
                CronParseValues={CronParseValues}
                flowName={flowName}
                schedularData={schedularData}
              />
            </Tooltip>
          )}
        </Overlay>
      ) : (
        ""
      )}
      {modalShow && (
        <DeleteModal
          payload={DeletePayload}
          url={API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS}
          show={modalShow}
          bindlist={callFunction}
          onHide={(e) => setModalShow(false)}
        />
      )}
      {/* <LogModal show={modalShow1} onHide={() => setModalShow1(false)} /> */}
      {modalShow1 && (
        <WorkFlowLogModal
          show={modalShow1}
          id={workFlowId}
          onHide={() => setModalShow1(false)}
        />
      )}
      {showNotification ? (
        <>
          <Overlay
            ref={overlayNoti_Ref}
            target={target2.current}
            show={showNotification}
            placement="bottom"
          >
            {(props) => (
              <Tooltip id="overlay-example" {...props}>
                <NotificationPopup
                  closePopup={handleshowNotification}
                  associationId={notificationPayloadRef.current?.associationId}
                  associationType={
                    notificationPayloadRef.current?.associationType
                  }
                />
              </Tooltip>
            )}
          </Overlay>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default SingleProjectCard;
